import React from 'react';

import OrderStickyStepper from '../../../OrderForm/components/OrderStickyStepper';
import { useOrderItemsModule } from '../../../OrderForm/contexts/OrderItemsModuleContext';

const SteelOrderStepper: React.FC = () => {
  const { navigation } = useOrderItemsModule();

  return (
    <OrderStickyStepper
      itemsLabel={navigation.itemsLabel}
      itemEntries={navigation.entries}
      onSelectItem={navigation.onSelectItem}
    />
  );
};

export default SteelOrderStepper;
